import { frontendURL } from '../../../../helper/URLHelper';
import { parseBoolean } from '@chatwoot/utils';

const ProfileSettingsWrapper = () => import('./ProfileSettingsWrapper.vue');
const Index = () => import('./Index.vue');
const NotificationSettings = () => import('./NotificationSettings.vue');
const MfaSettings = () => import('./MfaSettings.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/profile'),
      redirect: to => ({
        name: 'profile_settings_index',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/profile/settings'),
      redirect: to => ({
        name: 'profile_settings_index',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/profile/notifications'),
      redirect: () => ({
        name: 'profile_settings_notifications',
      }),
    },
    {
      path: frontendURL('accounts/:accountId/user/notifications'),
      redirect: () => ({ name: 'profile_settings_notifications' }),
    },
    {
      path: frontendURL('accounts/:accountId/profile/mfa'),
      redirect: to => ({
        name: 'profile_settings_mfa',
        params: { accountId: to.params.accountId },
      }),
    },
    {
      path: frontendURL('accounts/:accountId/user'),
      name: 'profile_settings',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: ProfileSettingsWrapper,
      children: [
        {
          path: 'user-profile',
          name: 'profile_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
          },
        },
        {
          path: 'mfa',
          name: 'profile_settings_mfa',
          component: MfaSettings,
          meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
            hideProfileInnerNav: true,
          },
          beforeEnter: (to, from, next) => {
            // Check if MFA is enabled globally
            if (!parseBoolean(window.chatwootConfig?.isMfaEnabled)) {
              // Redirect to profile settings if MFA is disabled
              next({ name: 'profile_settings_index' });
            } else {
              next();
            }
          },
        },
      ],
    },
  ],
};

export const userNotificationRoutes = [
  {
    path: 'ai-connections',
    component: ProfileSettingsWrapper,
    children: [
      {
        path: '',
        name: 'profile_ai_connections',
        component: () => import('./AiConnections.vue'),
        meta: { permissions: ['administrator', 'agent', 'custom_role'] },
      },
    ],
  },
  {
    path: 'notifications',
    component: ProfileSettingsWrapper,
    children: [
      {
        path: '',
        name: 'profile_settings_notifications',
        component: NotificationSettings,
        meta: {
          permissions: ['administrator', 'agent', 'custom_role'],
        },
      },
    ],
  },
];
